export const GET_FEE_SUMMARIES_REQUEST = 'GET_FEE_SUMMARIES_REQUEST';
export const GET_FEE_SUMMARIES_SUCCESS = 'GET_FEE_SUMMARIES_SUCCESS';
export const GET_FEE_SUMMARIES_FAILURE = 'GET_FEE_SUMMARIES_FAILURE';

export const GET_FEE_BY_ID_REQUEST = 'GET_FEE_BY_ID_REQUEST';
export const GET_FEE_BY_ID_SUCCESS = 'GET_FEE_BY_ID_SUCCESS';
export const GET_FEE_BY_ID_FAILURE = 'GET_FEE_BY_ID_FAILURE';

export const POST_FEE_REQUEST = 'POST_FEE_REQUEST';
export const POST_FEE_SUCCESS = 'POST_FEE_SUCCESS';
export const POST_FEE_FAILURE = 'POST_FEE_FAILURE';

export const UPDATE_FEE_REQUEST = 'UPDATE_FEE_REQUEST';
export const UPDATE_FEE_SUCCESS = 'UPDATE_FEE_SUCCESS';
export const UPDATE_FEE_FAILURE = 'UPDATE_FEE_FAILURE';

export const DELETE_FEE_REQUEST = 'DELETE_FEE_REQUEST';
export const DELETE_FEE_SUCCESS = 'DELETE_FEE_SUCCESS';
export const DELETE_FEE_FAILURE = 'DELETE_FEE_FAILURE';

export const SET_FEE_ID = 'SET_FEE_ID';

export const UPDATE_FEE_STATUSES_REQUEST = 'UPDATE_FEE_STATUSES_REQUEST';
export const UPDATE_FEE_STATUSES_SUCCESS = 'UPDATE_FEE_STATUSES_SUCCESS';
export const UPDATE_FEE_STATUSES_FAILURE = 'UPDATE_FEE_STATUSES_FAILURE';

export const INSERT_FEE_COMMENT_REQUEST = 'INSERT_FEE_COMMENT_REQUEST';
export const INSERT_FEE_COMMENT_SUCCESS = 'INSERT_FEE_COMMENT_SUCCESS';
export const INSERT_FEE_COMMENT_FAILURE = 'INSERT_FEE_COMMENT_FAILURE';